"use client";

import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { CONVO_MARK_PATH } from "@ui/convoMark";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body
        style={{
          fontFamily: "system-ui, sans-serif",
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          margin: 0,
          backgroundColor: "#fafaf9",
          color: "#1a1a1a",
        }}
      >
        <div style={{ textAlign: "center", padding: "2rem", maxWidth: "28rem" }}>
          <div
            style={{ display: "inline-block", transform: "rotate(-12deg)", marginBottom: "1.5rem" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 32 32"
              fill="none"
            >
              <g transform="translate(32 0) scale(-1 1)">
                <path d={CONVO_MARK_PATH} fill="#c8c8c4" />
                <circle cx="9" cy="16" r="2" fill="#fff" opacity="0.6" />
                <circle cx="16" cy="16" r="2" fill="#fff" opacity="0.4" />
                <circle cx="23" cy="16" r="2" fill="#fff" opacity="0.2" />
                {/* crack */}
                <path
                  d="M20 3 L15 13 L19 13 L13 27"
                  stroke="#9ca3af"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
          </div>
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: "0.5rem" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#6b7280", marginBottom: "1.5rem", lineHeight: 1.6 }}>
            An unexpected error occurred. The error has been reported.
          </p>
          <button
            onClick={reset}
            style={{
              backgroundColor: "#e85d49",
              color: "white",
              border: "none",
              borderRadius: "0.5rem",
              padding: "0.625rem 1.25rem",
              fontSize: "0.9375rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
